import React from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import { keys, map } from 'lodash';

import FiltersSelectContent from '../FiltersSelectContent';

const messages = defineMessages({
  outbound: {
    id: 'core.FiltersDialog.components.FilterMessageType.outbound',
    defaultMessage: 'Sent to patient',
  },
  inbound: {
    id: 'core.FiltersDialog.components.FilterMessageType.inbound',
    defaultMessage: 'Received from patient',
  },
});

export function useFiltersMessageTypeItems() {
  const { formatMessage } = useIntl();

  const itemIds = keys(messages) as (keyof typeof messages)[];
  return map(itemIds, (id) => ({
    _id: id,
    label: formatMessage(messages[id]),
  }));
}

const FiltersMessageType: React.FC = () => {
  const items = useFiltersMessageTypeItems();

  return <FiltersSelectContent type="messageType" items={items} />;
};
export default FiltersMessageType;
